export enum DateFields {
  CREATED_AT= 'createdAt',
  DUE_ON= 'dueOn',
  COMPLETED_AT='completedAt',
  ASSIGNED_AT ='assignedAt',
}
